import { render, staticRenderFns } from "./navigationButtom.vue?vue&type=template&id=4ff2a18b&scoped=true"
import script from "./navigationButtom.vue?vue&type=script&lang=js"
export * from "./navigationButtom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff2a18b",
  null
  
)

export default component.exports